import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Checkbox, Dropdown, Field, TextOutput } from '../../Core';
import * as oPath from '../../../Lib/Object/Path/Immutable';
import { ListFieldSection, PageSection } from '../../Layout';

const SieveEquipment = () => {
  const selectedSieveSize = useSelector((state) => state.equipment.syncModel.data.SieveSizeId);
  const [showCommon, setShowCommon] = useState(true);
  const availableSieveSizes = useSelector((state) => {
    let allSieveSizes = oPath.get(state, `equipment.syncModel.data.AllSieveSizes`);
    return showCommon ? allSieveSizes.filter((s) => !!s.IsCommon || s.Id === selectedSieveSize) : allSieveSizes;
  });

  const sieveSizeOptions = availableSieveSizes?.map((s) => ({ value: s.Id, label: s.Caption }));

  return (
    <>
      <PageSection heading="Sieve Size">
        <ListFieldSection>
          <Field input={<TextOutput />} label="Sieve" name="Code" />
          <Field
            input={<Checkbox />}
            label="Only show common sieve sizes"
            value={showCommon}
            onChange={(e) => setShowCommon(e.target.checked)}
          />
          <Field input={<Dropdown />} label="Sieve Size" name="SieveSizeId" options={sieveSizeOptions} simpleValue />
        </ListFieldSection>
      </PageSection>
    </>
  );
};

export default SieveEquipment;
export { SieveEquipment };
